import { useEffect } from 'react';
import { GameState, GamePhase, GameAction } from '../types';
import * as gameLogic from '../services/gameLogic';

export const useBrokenSecret = (
    gameState: GameState | null,
    localPlayerId: number,
    executeGameAction: (action: GameAction, localUpdate: (state: GameState) => GameState) => void
) => {
    useEffect(() => {
        if (!gameState) return;
        if (gameState.phase !== GamePhase.BROKEN_SECRET_REVEAL) return;

        // Only the initiator needs to trigger the "COMPLETE" action
        // brokenSecretState.initiatorId is the one who played the card.

        const { brokenSecretState } = gameState;
        if (!brokenSecretState) return;

        if (brokenSecretState.initiatorId === localPlayerId) {
            const duration = brokenSecretState.revealDuration || 3000;

            const timer = setTimeout(() => {
                executeGameAction(
                    { type: 'COMPLETE_BROKEN_SECRET', playerId: localPlayerId },
                    (state) => gameLogic.completeBrokenSecret(state)
                );
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [gameState?.phase, gameState?.brokenSecretState, localPlayerId]);
};
